exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1pbQ {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n._3Pt0 {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    max-height: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"imageContainer": "_1pbQ",
	"image": "_3Pt0"
};